import { format } from 'date-fns';

import { useSelfExclusionData } from '@swf/account';

export const useFormattedSelfExclusionDate = () => {
  const { selfExclusionData } = useSelfExclusionData();
  const { timeUntil } = selfExclusionData || {};

  return format(timeUntil ?? new Date(), 'dd/MM/yyyy, hh:mma');
};
